import styled from "styled-components";

export const BORDER = "#E5E7EB";
export const WHITE = "#FFFFFF";
export const CRITICAL_RED = "#B91C1C";

export const Card = styled.section`
  background: ${WHITE};
  border: 1px solid ${BORDER};
  border-radius: 8px;
  min-width: 0;
  padding: 16px;
`;

export const CardTitle = styled.h2`
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 2px;
`;
